<template>
    <div>
        <div class="row">
            <div class="col header text-left">
                <h1>Entwickelt. Plant. Realisiert.</h1>
            </div>
            <div class="col jubilee-wrapper">
                <img
                    src="../assets/images/logo/jubilee_emblem_ic_2024.png"
                    class="jubilee"
                    alt="Jubiläumsemblem"
                    height="60"
                    align="right"
                />
            </div>
        </div>
        <div class="row gallery-padding">
            <div
                v-for="(item, index) in config.home"
                class="col-lg-4 col-md-6 col-12 gallery-item"
                v-bind:class="{'d-lg-block d-xl-block d-none' : item.isBlank }"
            >
                <div v-if="!item.isBlank" class="responsive-image-container"
                    @click="showModal(index)"
                    :key="index">
                    <img
                        v-if="!item.isLivecamImage"
                        :src="getImageURL(item.image)"
                        class="responsive-image"
                        v-bind:alt="item.name"
                    />
                    <div v-else class="live-cam">
                        <img
                            :src="item.livecamLatestURL"
                            class="responsive-image"
                            style="object-fit: cover;"
                            id="live-cam-small-screen"
                            alt="Livecam"
                        />
                    </div>
                    <div class="overlay">
                        <div class="overlay-text h2">
                            {{ item.companyName }}<br />
                            <div class="overlay-text-light">
                                {{ item.responsibility }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="responsive-image-container"></div>
                <b-modal
                    :ref="`modal-${index}`"
                    :key="item.name"
                    :id="item.name"
                    :hide-footer="true"
                    :hide-header="false"
                    size="xl"
                >
                    <gallery-modal-content :images="item.images" />
                    <div v-if="item.isLivecamImage">
                        <iframe
                            v-for="(cam, index) in item.cams"
                            :src="cam"
                            class="modal-livecam embed-responsive embed-responsive-16by9"
                            height="525"
                            frameborder="0"
                            :key="index + 100"
                        />
                    </div>
                </b-modal>
            </div>
        </div>
        <immo-footer />
        <vue-cookie
            :debug="false"
            :position="'bottom'"
            :disableDecline="false"
            :transitionName="'slideFromBottom'"
            @status="cookieStatus"
            @clickedAccept="cookieClickedAccept"
            @clickedDecline="cookieClickedDecline">

            <div slot="message">
                Diese Website verwendet Cookies um Dienste bereitzustellen und Zugriffe zu analysieren. <a href="https://www.immocoach.com/privacy/" target="_blank">Mehr erfahren...</a>
            </div>
            <div slot="declineContent">
                Ablehnen
            </div>
            <div slot="acceptContent">
                Einverstanden
            </div>
        </vue-cookie>
    </div>
</template>

<script>
import GalleryModalContent from './home/GalleryModalComponent.vue'
import ImmoFooter from './Footer.vue'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'

export default {
    name: 'home',
    components: {
        GalleryModalContent,
        ImmoFooter,
        'vue-cookie': VueCookieAcceptDecline
    },
    props: {
        config: ''
    },
    methods: {
        showModal(index) {
            let entries = Object.entries(this.$refs)
            let filteredEntry = entries.filter(
                object => object[0] === `modal-${index}`
            )[0]
            let modal = filteredEntry[1][0]
            modal.show()
            Array.from(
                document.getElementsByClassName('modal-livecam')
            ).forEach(function(cam) {
                cam.src = cam.src
            })
        },
        hideModal() {
            this.$refs.my_modal.hide()
        },
        getImageURL(imageName) {
            return require('../assets/images/companies/' + imageName)
        }
    }
}
</script>

<style>
#app .modal-lg {
    max-width: 1170px;
}
</style>

<style lang="scss" scoped>
@import '../styles/main.scss';

.carousel-control-next-icon {
    background-color: red;
}

.gallery-padding {
    padding-left: 15px;
    padding-right: 15px;
}

.gallery-item {
    padding: 0;
}

.gallery-item:hover .overlay {
    opacity: 0.86;
}

.responsive-image-container {
    height: 65vw;
}

@media (min-width: 768px) {
    .responsive-image-container {
        height: 30vw;
    }
}

@media (min-width: 992px) {
    .responsive-image-container {
        height: 20vw;
    }
}

.responsive-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: 0.5s ease;
    background-color: $immocoach-blue;
    cursor: pointer;
    cursor: hand;
}

.overlay-text {
    color: #ffffff;
    position: relative;
    float: left;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 30px;
    font-family: 'miso-bold', Arial, sans-serif;
}

.overlay-text-light {
    font-family: 'miso-light', Arial, sans-serif;
}

.header {
    font-family: 'miso-light', Arial, sans-serif;
    padding-top: 110px;
    padding-bottom: 80px;
    padding-left: $main-indent;
    padding-right: $main-indent;
}

.jubilee-wrapper {
    padding-top: 95px;
    padding-bottom: 80px;
    padding-left: $main-indent;
    padding-right: $main-indent;
}

.header h1 {
    font-size: 50px;
}

.live-cam {
    background: no-repeat center;
    background-size: cover;
    width: 100%;
    height: 100%;
}

.live-cam-small-screen {
    display: none;
}

@media only screen and (max-width: 767px) {
    #live-cam-small-screen {
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeComponent.vue